import React, { FC, Fragment } from 'react';
import {
  makeStyles,
  createStyles,
  Theme,
  IconButton,
  Typography,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  Tooltip,
  Grid
} from '@material-ui/core';
import { RED } from 'constants/colors';
import { TableCellEnd, TableCellMiddle, TableCellStart, TableRowCustom, TableRowCollapse } from 'components';
import { format } from 'date-fns';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import NumberFormat from 'components/NumberFormat';
import Skeleton from '@material-ui/lab/Skeleton';
import useRouter from 'hooks/useRouter';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import HasPrint from 'images/icon/PrintIndicator3.png';

interface Props {
  number: number;
  purchaseInvoice: PurchaseInvoiceModel;
  isLoading: boolean;
  openCollapse: boolean;
  index: number;
  isNotAllowCreate: boolean;
  statusInvoice: string;
  indexCollapse: number;
  collapseLoading: boolean;
  onDelete: React.MouseEventHandler;
  handleOpenCollapse: React.MouseEventHandler;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    deleteButton: {
      color: RED,
      width: 30
    },
    tableCellAction: {
      width: 30
    },
    customerName: {
      fontSize: '15px',
      fontWeight: 500,
      fontFamily: 'Rubik',
      fontStyle: 'normal',
      lineHeight: '22px'
    },
    tableCollapse: {
      width: '100%'
    },
    cellCollapse: {
      border: 'none'
    }
  })
);

const BodyRow: FC<Props> = props => {
  const {
    purchaseInvoice,
    isLoading,
    statusInvoice,
    openCollapse,
    index,
    isNotAllowCreate,
    indexCollapse,
    collapseLoading,
    onDelete,
    handleOpenCollapse
  } = props;
  const { history } = useRouter();
  const classes = useStyles();
  const { number } = props;

  const handleLink = () => {
    history.push('/invoice-pembelian/detail', { id: purchaseInvoice.id });
  };

  return (
    <Fragment>
      <TableRowCustom>
        <TableCellStart>
          {isLoading ? (
            <Skeleton variant='text' width={60} height={25} />
          ) : (
            <IconButton aria-label='expand row' size='small' onClick={handleOpenCollapse}>
              {openCollapse && index === indexCollapse ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCellStart>
        <TableCellMiddle onClick={handleLink}>{isLoading ? <Skeleton variant='text' width={60} height={25} /> : number + 1}</TableCellMiddle>
        <TableCellMiddle onClick={handleLink}>
          {isLoading ? <Skeleton variant='text' width={60} height={25} /> : '#' + purchaseInvoice.invoiceNumber}
        </TableCellMiddle>

        <TableCellMiddle onClick={handleLink}>
          {isLoading ? <Skeleton variant='text' width={60} height={25} /> : '#' + purchaseInvoice.invoiceNumberSupplier}
        </TableCellMiddle>

        <TableCellMiddle onClick={handleLink}>
          {isLoading ? (
            <Skeleton variant='text' width={150} height={25} />
          ) : (
            <Typography variant='inherit' component='p' className={classes.customerName}>
              {purchaseInvoice.Partner ? purchaseInvoice.Partner.name : '-'}
            </Typography>
          )}
        </TableCellMiddle>

        <TableCellMiddle align='right' onClick={handleLink}>
          {isLoading ? (
            <Skeleton variant='text' width={120} height={25} />
          ) : (
            <NumberFormat value={purchaseInvoice.totalPrice} prefix={'Rp'} thousandSeparator={true} displayType='text' />
          )}
        </TableCellMiddle>

        {/* <TableCellMiddle onClick={handleLink} align='center'>
          {isLoading ? <Skeleton variant='text' width={120} height={25} /> : purchaseInvoice.totalItem}
        </TableCellMiddle> */}

        <TableCellMiddle onClick={handleLink} align='center'>
          {isLoading ? <Skeleton variant='text' width={120} height={25} /> : format(new Date(purchaseInvoice.orderDate), 'dd MMM yyyy')}
        </TableCellMiddle>
        {/* <TableCellMiddle onClick={handleLink}>
          <Grid xs={12} container justify='space-around' alignItems='center'>
            {isLoading ? <Skeleton variant='text' width={120} height={25} /> : statusInvoice.includes('CANCEL') ? 'Batal' : 'Konfirmasi'}
            {purchaseInvoice.isPrint && <img src={HasPrint} alt='image' width={50} height={40} />}
          </Grid>
        </TableCellMiddle> */}

        <TableCellEnd align='center' className={classes.tableCellAction}>
          {isLoading ? (
            <Skeleton variant='text' width={'100%'} height={25} />
          ) : (
            !isNotAllowCreate && (
              <Tooltip title='Hapus '>
                <IconButton size='small' onClick={onDelete} disabled={statusInvoice.includes('CANCEL')}>
                  <DeleteOutline fontSize='small' />
                </IconButton>
              </Tooltip>
            )
          )}
        </TableCellEnd>
      </TableRowCustom>
      <TableRowCollapse open={openCollapse && index === indexCollapse} colSpan={8}>
        <Table className={classes.tableCollapse} size='small'>
          <TableHead>
            <TableRow>
              <TableCell>No</TableCell>
              <TableCell>Nama</TableCell>
              <TableCell align='center'>Kuantitas</TableCell>
              <TableCell align='right'>Harga Satuan</TableCell>
              <TableCell align='right'>Total</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {collapseLoading && (
              <TableRow key={index}>
                <TableCell colSpan={3}>
                  <Skeleton variant='text' width='200%' height={25} />
                </TableCell>
              </TableRow>
            )}

            {purchaseInvoice.PurchaseInvoiceItem &&
              purchaseInvoice.PurchaseInvoiceItem.map((value: PurchaseInvoiceItemModel, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.cellCollapse}>{index + 1}</TableCell>
                  <TableCell className={classes.cellCollapse}>{value.Product ? value.Product.productName : '-'}</TableCell>
                  <TableCell align='center' className={classes.cellCollapse}>
                    {value.Product ? value.totalItem + ' ' + value.typeUnit : 0}
                  </TableCell>
                  <TableCell align='right' className={classes.cellCollapse}>
                    <NumberFormat value={value.price} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                  </TableCell>
                  <TableCell align='right' className={classes.cellCollapse}>
                    <NumberFormat value={value.totalPrice} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableRowCollapse>
    </Fragment>
  );
};

export default BodyRow;
